import React from 'react'
import './search-bar.styles.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { useSelector } from 'react-redux';

const SearchBar = ({ search, idLabel }) => {

    const screenSize = useSelector(state => state.listsData.screenSize);

    return (
        <div className='search-box'>
            <input 
                type="text" 
                className={`search-input ${screenSize}`} 
                id={idLabel ?? ''}
                placeholder="Search..." 
                onChange={(e) => search(e.target.value, idLabel)} 
            />
            <div className={`search-icon ${screenSize}`}>
                <FontAwesomeIcon icon={faSearch} />
            </div>
        </div>
    )
}

export default SearchBar